// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1--aa","empty":"ModalGraph_empty__NEf2O"};